module.exports = __webpack_public_path__ + "static/img/team-business.cdd82101.png";